<template lang="pug">
  transition(name='drawer' v-if='showNotificationsDrawer')
    .container.column(v-on-clickaway='hide')
      .header.row.middle
        simple-svg.white-icon.m-right-1(:filepath='notificationsIcon' width='20px' height='20px')
        h2.text-normal.white.m4-bottom-1 {{ $t('notifications.whatsNew') }}
        button.m-left-auto(@click='hide')
          simple-svg.white-icon(:filepath='crossIcon' width='20px' height='20px')
      .item-1.list.kimple-scroll
        loader(v-if='loading' size='inner')
        notification-card(
          v-if='!loading && !showDetail'
          @showDetail='displayDetail'
          v-for='notification in notifications'
          :notification='notification'
        )
        button.primary-button.load-more(
          v-if='showLoadMore && !showDetail'
          @click='loadMore'
          :disabled='loadingMore'
        ) {{ $t('notifications.loadMore') }}
        .column(v-if='!loading && showDetail')
          .row.m-bottom-1
            button.m-right-1(@click='hideDetail')
              simple-svg(:filepath='arrowLeft' width='18px' height='18px')
            h2.text-normal {{ $t("notifications.backToList") }}
          notification-card(:notification='notificationSelected' withDetail)
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import notificationsIcon from '@/assets/ic_notification.svg'
import crossIcon from '@/assets/ic_cross.svg'
import NotificationCard from './NotificationCard'
import { mapActions, mapState } from 'vuex'
import Loader from '../Loader'
import arrowLeft from '@/assets/ic_chevron-left.svg'

export default {
  mixins: [clickaway],
  components: { NotificationCard, Loader },
  data() {
    return {
      notificationsIcon,
      arrowLeft,
      crossIcon,
      loading: true,
      loadingMore: false,
      showDetail: false,
      notificationSelected: null,
      pageSize: 5,
      pageNumber: 0
    }
  },
  watch: {
    async showNotificationsDrawer() {
      if (this.showNotificationsDrawer) {
        await this.getPage()
        await this.markNotificationsSeen()
        this.loading = false
      } else {
        this.loading = true
        this.pageNumber = 0
        this.clearNotifications()
      }
    }
  },
  computed: {
    ...mapState({
      showNotificationsDrawer: state => state.behavior.notificationsDrawer.show,
      notifications: state => state.notifications.notifications.notifications,
      totalCount: state => state.notifications.notifications.totalCount,
      pages: state => state.notifications.notifications.pages
    }),
    showLoadMore() {
      return this.pageNumber + 1 < this.pages
    }
  },
  methods: {
    ...mapActions([
      'hideElement',
      'hydrateNotifications',
      'markNotificationsSeen',
      'clearNotifications'
    ]),
    async getPage() {
      await this.hydrateNotifications({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      })
    },
    async loadMore() {
      this.pageNumber = this.pageNumber + 1
      this.loadingMore = true
      await this.getPage()
      this.loadingMore = false
    },
    displayDetail(notification) {
      this.showDetail = true
      this.notificationSelected = notification
    },
    hideDetail() {
      this.showDetail = false
      this.notificationSelected = null
    },
    hide() {
      this.hideDetail()
      this.hideElement({ element: 'notificationsDrawer' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/sizes';

.container{
  position: fixed;
  z-index: 2;
  width: 430px;
  margin-top: $navbar-height;
  height: calc(100vh - #{$navbar-height});
  right: 0;
  top: 0;
  background-color: $white;
}

.load-more{
  width: 100%;
  max-width: none;
  margin-top: 10px;
  background-color: $black;
  border-color: $black;
  &:hover{
    color: $black !important;
  }
  &:active{
    background-color: $black !important;
    border-color: $black !important;
  }
  &:focus{
    border-color: $black !important;
  }
}

.header{
  background-color: $black;
  padding: 0 10px;
  height: 50px;
}

.list{
  border-left: 1px solid $gray;
  padding: 10px;
  overflow-y: auto;
  &>*:not(:last-child){
    margin-bottom: 10px;
  }
}

.drawer-enter, .drawer-leave-to{
  transform: translate(100%);
  opacity: 0;
}

.drawer-enter-active, .drawer-leave-active{
  transition: all .3s ease;
}
</style>
